import React from 'react'
import Subtitle from '../components/UI/Subtitle'
import CatalogRequest from '../components/CatalogRequest'
import { FormattedMessage } from "react-intl"
import DashboardLinks from '../components/Navigation/DashboardLinks'

const Catalog = () => {
  return (
    <>
      <DashboardLinks />
      <div className="p-4 text-black">
        <Subtitle><FormattedMessage id="app.privateMenu.colorCards" defaultMessage="Catalogs" />:</Subtitle>
        <hr className='mt-4 mb-4'></hr>
        <CatalogRequest />
      </div>
    </>
  )
}

export default Catalog